
    require('./graphic');
    require('../zrender').registerPainter('vml', require('./Painter'));



//////////////////
// WEBPACK FOOTER
// ./~/zrender/lib/vml/vml.js
// module id = VmZa
// module chunks = 5